var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.posts.length)?_c('section',{staticClass:"m-similar-posts"},[_c('div',{staticClass:"m-similar-posts__title"},[_c('h3',[_vm._v(" "+_vm._s(_vm.$t('blog.similar_articles_title'))+" ")])]),_c('div',{staticClass:"m-similar-posts__posts"},[_vm._l((_vm.posts),function(post){return [_c('router-link',{key:post.id,staticClass:"router-link-post",attrs:{"to":{
                    name: 'blog-single',
                    params: {slug: post.slug}
                }}},[_c('y-blog-card',{attrs:{"post-data":post}})],1)]})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }